import React from "react";
import Form from "react-bootstrap/Form";
import { useField } from "formik";
import { FormControlProps } from "react-bootstrap";
import { omit } from "lodash";
import { base64 } from "src/app/utils/formHelpers";
import { KTSVG } from "src/_metronic/helpers";
import { useIntl } from "react-intl";

interface SimpleImageUploadProps {
    label?: string;
    name: string;
    autoFocus?: boolean;
    cssClass?: string[];
    disabled?: boolean;
    [key: string]: any;
}

export const SimpleImageUpload: React.FC<SimpleImageUploadProps & FormControlProps> = (props) => {
    const { label, autoFocus = false, placeholder, name, disabled = false } = props;
    const { formatMessage } = useIntl();
    const [, formikMetaProps, formikHelper] = useField(name);

    return (
        <div
            className={`simpleImageUploadWrapper ${
                formikMetaProps?.value ? "hasImage" : "notHaveImage"
            } `}
        >
            {label && <Form.Label>{label}</Form.Label>}
            {formikMetaProps?.value ? (
                <img src={formikMetaProps?.value?.fileBase64} />
            ) : (
                <div className="uploadInfo">
                    <KTSVG path="/media/icons/duotune/arrows/arr078.svg" className="svg-icon-2" />
                    <Form.Label>{formatMessage({ id: "common.field.updateImage" })}</Form.Label>
                </div>
            )}
            <input
                disabled={disabled}
                type="file"
                accept="image/*"
                placeholder={placeholder}
                autoFocus={autoFocus}
                onChange={(e) => {
                    const files = e.currentTarget.files;
                    if (files && files?.length > 0) {
                        formikHelper.setValue(files);
                        base64(files[0])
                            .then((res) => {
                                formikHelper.setValue({
                                    fileName: files[0].name,
                                    fileBase64: res,
                                });
                            })
                            .catch((error) => formikHelper.setError(error));
                    }
                    [0];
                }}
                {...omit(props, "values")}
            />
        </div>
    );
};
